// extracted by mini-css-extract-plugin
export default {"pinedIcon":"AppPinButton_pinedIcon__h7yW+","button":"AppPinButton_button__zxIzF"};